import Vue from 'vue';
export default Vue.extend({
    props: {
        size: { type: String, required: false, default: 'normal',
            validator: function (value) {
                // The value must match one of these strings
                return ['mini', 'tiny', 'small', 'normal', 'large', 'big', 'huge', 'massive'].indexOf(value) !== -1;
            }
        },
        /** `true` for dark backgrounds */
        inverted: { type: Boolean, required: false, default: false },
        /** reverse the animation */
        reverse: { type: Boolean, required: false, default: false },
        /** slow, normal or fast */
        speed: { type: String, required: false, default: 'normal',
            validator: function (value) {
                // The value must match one of these strings
                return ['slow', 'normal', 'fast'].indexOf(value) !== -1;
            }
        },
        textPos: { type: String, required: false, default: 'right' },
    }
});
